import React from 'react';
import { string, number } from 'prop-types';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { Heading } from '@thd-olt-component-react/heading';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { QAContextProvider } from '../context/QAContext';
import { QAResultDesktop } from './QAResult/QAResultDesktop.component';
import { dataModel } from './dataModel';
import './QuestionsAndAnswers.scss';

const QuestionsAndAnswersDesktopComponent = ({ itemId, seoPageNumber }) => {
  return (
    <div className="grid questions-and-answers">
      <div className="qa-wrapper">
        <Heading title="Questions & Answers" underline />
        <QAContextProvider itemId={itemId} seoPageNumber={seoPageNumber}>
          <QueryProvider cacheKey="question-answer-desktop">
            <QAResultDesktop />
          </QueryProvider>
        </QAContextProvider>
      </div>
    </div>
  );
};

QuestionsAndAnswersDesktopComponent.displayName = 'QuestionsAndAnswersDesktop';

QuestionsAndAnswersDesktopComponent.propTypes = {
  itemId: string.isRequired,
  seoPageNumber: number
};

QuestionsAndAnswersDesktopComponent.defaultProps = {
  seoPageNumber: null
};

QuestionsAndAnswersDesktopComponent.dataModel = dataModel;

const HydratedComponent = withHydrator(
  {
    delay: 2000,
    id: 'product-section-qa',
    placeholder: (
      <ComponentPlaceholder
        height={680}
        rows={4}
        color="#E0E0E0"
        showLoadingAnimation
      />
    ),
    scrollBuffer: 750,
  },
  QuestionsAndAnswersDesktopComponent
);

const DynamicComponent = withDynamicComponent(HydratedComponent);
export const QuestionsAndAnswersDesktop = withLayoutGroup(
  { name: 'questions_answers_full' },
  DynamicComponent
);

QuestionsAndAnswersDesktop.propTypes = {
  itemId: string.isRequired,
  seoPageNumber: number
};

QuestionsAndAnswersDesktop.defaultProps = {
  seoPageNumber: null
};

QuestionsAndAnswersDesktop.dataModel = dataModel;
